import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-json-dialog',
  templateUrl: './json-dialog.component.html',
  styleUrls: ['./json-dialog.component.css']
})
export class JsonDialogComponent implements OnInit {

  displayContent: string = "";
  title: string = "";

  constructor(public dilaogRef: MatDialogRef<JsonDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any) { 
    this.data = data;
  }

  ngOnInit(): void {
    console.log("modal data: ", this.data);
    this.displayContent = JSON.stringify(this.data, null, 4);
  }

}
